import styled from 'styled-components';

const EditorStyle = styled.div`
	--marginT: var(--sp2x);
	--marginL: var(--sp9x);

	font-size: var(--p2);
	font-family: var(--fss);
	font-weight: 300;
	line-height: var(--lineHeightL);
	color: var(--green1000);
	white-space: pre-wrap;

	h5 {
		font-size: var(--h5);
		font-family: var(--fss);
		font-weight: 400;
		color: var(--green1000);
		line-height: var(--lineHeightS);
	}

	h6 {
		font-size: var(--h6);
		font-family: var(--fss);
		font-weight: 400;
		color: var(--green1000);
		line-height: var(--lineHeightS);
	}

	p {
		font-size: var(--p2);
		font-family: var(--fss);
		font-weight: 300;
		line-height: var(--lineHeightL);
		color: var(--green1000);
	}

	a {
		font-size: var(--p2);
		font-family: var(--fss);
		font-weight: 300;
		line-height: var(--lineHeightL);
		color: var(--yellow1000);
		text-decoration: underline;

		@media (hover: hover) {
			&:hover {
				text-decoration: none;
			}
		}
	}

	strong {
		font-weight: 500;
	}

	ol {
		list-style-position: inside;
		margin-left: var(--marginL);

		li {
			font-size: var(--p2);
			font-family: var(--fss);
			font-weight: 300;
			line-height: var(--lineHeightL);
			color: var(--green1000);
			margin-top: var(--marginT);

			&:first-child {
				margin-top: unset;
			}
		}
	}

	ul {
		list-style: disc;
		list-style-position: inside;
		margin-left: var(--marginL);

		li {
			font-size: var(--p2);
			font-family: var(--fss);
			font-weight: 300;
			line-height: var(--lineHeightL);
			color: var(--green1000);
			margin-top: var(--marginT);

			&:first-child {
				margin-top: unset;
			}
		}
	}

	blockquote {
		border-left: 3px solid var(--green1000);
		padding-left: 2vw;
		font-size: var(--p2);
		font-family: var(--fss);
		font-weight: 300;
		line-height: var(--lineHeightL);
		color: var(--green1000);
	}

	ul > li::marker {
		font-size: var(--p3);
	}

	ul > li.bold-marker::marker,
	ol > li.bold-marker::marker {
		font-weight: 500;
	}

	ul > li.bold-marker::marker {
		font-size: var(--p2);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginL: var(--sp8x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginL: var(--sp7x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp1-5x);
		--marginL: var(--sp6x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginL: var(--sp5x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp1x);
		--marginL: var(--sp4x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--marginL: var(--sp3x);
	}
`;

export default EditorStyle;
